import { Container, Grid2 } from "@mui/material";

export default function NotFound() {
  return (
    <Container sx={{ marginY: 5 }}>
      <Grid2 container spacing={3}>
        <div id="error-page">
          <h1>Oops!</h1>
          <p>You are in wrong location.</p>
        </div>
      </Grid2>
    </Container>
  );
}
